import { api } from "@/api/client";

/* Phase 28 — Career Cockpit Auto-Pilot.
   Instant context hydration + real LLM resume tailoring (non-registered facade,
   12-tool cap intact). */
export const careerCockpitApi = {
  context: () => api.get("/career-cockpit/context").then((r) => r.data),
  saveBaseResume: (resume_text, target_role) =>
    api.post("/career-cockpit/base-resume", { resume_text, target_role }).then((r) => r.data),
  tailor: (job_desc, resume_text) =>
    api.post("/career-cockpit/tailor", { job_desc, resume_text }).then((r) => r.data),
  saveTailored: (content, title) =>
    api.post("/career-cockpit/save-tailored", { content, title }).then((r) => r.data),
  applyPack: (payload) =>
    api.post("/career-cockpit/apply-pack", payload).then((r) => r.data),
  refreshResume: (payload) =>
    api.post("/career-cockpit/refresh-resume", payload).then((r) => r.data),
  savedResumes: () =>
    api.get("/career-cockpit/saved-resumes").then((r) => r.data),
};
